import planitio from "../../../../public/images/planitio.webp";
import iaga from "../../../../public/images/iaga.webp";
import propbuying from "../../../../public/images/propbuying.webp";
import pintags from "../../../../public/images/pintags.webp";

/**
 * List of projects that are finished
 */
export const fineshedProjects = [
  {
    id: 1,
    title: "Planit.io",
    description: "Meeting scheduling app made for teams and individuals alike.",
    imageSrc: planitio,
    href: "https://planitio.tarunsharma.dev",
    backgroundColor: "#2E6AECb0",
  },
  {
    id: 2,
    title: "IAGA",
    description:
      "Dynamic website, webapp and an admin panel for an animation training institute.",
    imageSrc: iaga,
    href: "https://iagainstitute.com",
    backgroundColor: "#19B69Db0",
  },
  {
    id: 3,
    title: "Propbuying",
    description: "Real estate website for buying and selling properties.",
    imageSrc: propbuying,
    href: "https://www.propbuying.com",
    backgroundColor: "#F37A20b0",
  },
];

/**
 * List of projects that are still in progress
 */
export const onGoingProjects = [
  {
    id: 1,
    title: "Bookmark Manager",
    description:
      "Bookmark manager with a browser extension that tags and describes saved links with AI.",
    imageSrc: pintags,
    href: "#",
    backgroundColor: "#0F0F0F",
  },
];
